// Simple fetch-based speakers service as fallback
import { getImageUrl } from './api';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001/api';

export const speakersService = {
  async getSpeakers(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = `${API_BASE_URL}/speakers${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        // Add timeout using AbortController
        signal: AbortSignal.timeout(5000) // 5 seconds timeout
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      // Format photo and PDF URLs
      if (data && data.success && Array.isArray(data.data)) {
        data.data = data.data.map(item => ({
          ...item,
          photo_url: getImageUrl(item.photo_url),
          pdf_url: getImageUrl(item.pdf_url)
        }));
      }

      return data;
    } catch (error) {
      console.error('Speakers service error:', error);
      throw error;
    }
  }
};

export default speakersService;